import { computed, Directive, inject, input } from '@angular/core';
import { CacheService } from './auth.service';

@Directive({
  selector: '[plan]',
  standalone: true,
  // inputs: ['inverted', 'palette', 'nobg']
  host: {
    '[style.background]': '_background()',
    '[style.color]': '_foreground()',
    '[style.border]': '_stroked()',
  }
})
export class PlanStyleDirective {
  cache = inject(CacheService);

  plan = input.required<string>();
  design = input<'flat' | 'fancy' | 'inverted' | 'text'>('flat'); 
  stroked = input<number>(0);

  private styles = computed(() => {
    const plan = this.plan();
  
    const { color_settings } = this.cache.registeredPlans().find(rp => rp.identifier == plan)!;
    //  || { 
    //   color_settings: {
    //     background: '#8491af',
    //     foreground: '#0075ff',
    //     gradient_horizontal: [{ color: '#8491af', stop: 0 }, { color: '#8491af', stop: 100 }]
    //   }
    // };
  
    switch(this.design()){
      case 'flat': return [color_settings.background, color_settings.foreground];
      case 'inverted': return [color_settings.foreground, color_settings.background];
      case 'text': return [undefined, color_settings.background];
      case 'fancy': {

        let horizontal = null;
        if(typeof color_settings.gradient_horizontal == 'string'){
          horizontal = color_settings.gradient_horizontal;
        } else {
          horizontal = `linear-gradient(180deg, ${color_settings.gradient_horizontal.map(entry => `${entry.color} ${entry.stop}%`).join(', ')})`;
        }

        return [horizontal,color_settings.foreground];
      }
    }
  });

  private _background = computed(() => this.styles()[0]);
  private _foreground = computed(() => this.styles()[1]);
  private _stroked = computed(() => this.stroked() && ['inverted', 'text'].includes(this.design()) ? `${this.stroked()}px solid ${this._foreground()}` : undefined);
}